/**
 * Vista por rol del handbook del agente (`src/data/agentHandbook.json`).
 *
 * El JSON ya trae, para cada frase / paso / base de conocimiento, la lista de
 * roles que pueden usarla (calculada en el servidor desde el registry de tools).
 * Estas funciones sólo FILTRAN; no deciden permisos. Si hay que cambiar quién
 * puede qué, se cambia el registry y se regenera el JSON (`npm run docs:handbook`
 * en mcp-server/), nunca acá.
 *
 * @module utils/agentHandbookView
 */

export const HANDBOOK_ROLES = ['admin', 'supervisor', 'technician', 'client'];

export const esRolDelHandbook = (role) => HANDBOOK_ROLES.includes(role);

/**
 * Áreas con las frases que `role` puede pedir. Las áreas que quedan vacías para
 * ese rol se omiten (un cliente no ve "Herramientas").
 *
 * @param {object} handbook
 * @param {string} role
 * @param {{soloProbadas?: boolean}} [opts]
 */
export const habilidadesParaRol = (handbook, role, { soloProbadas = false } = {}) =>
  (handbook?.areas || [])
    .map((area) => ({
      ...area,
      habilidades: area.habilidades.filter(
        (h) => h.roles.includes(role) && (!soloProbadas || h.probada)
      ),
    }))
    .filter((area) => area.habilidades.length > 0);

/** Flujos en los que `role` participa en al menos un paso. */
export const flujosParaRol = (handbook, role) =>
  (handbook?.flujos || []).filter((f) => f.pasos.some((p) => p.roles.includes(role)));

export const conocimientoParaRol = (handbook, role) =>
  (handbook?.conocimiento || []).filter((c) => c.roles.includes(role));

export const novedadesParaRol = (handbook, role) =>
  (handbook?.novedades || []).filter((n) => n.roles.includes(role));

/** "el Administrador" / "el Administrador o el Supervisor" para el paso que no es tuyo. */
export const quienHaceElPaso = (handbook, roles) => {
  const nombres = roles.map((r) => handbook?.roles?.[r]?.etiqueta || r);
  if (nombres.length === 0) return '';
  if (nombres.length === 1) return nombres[0];
  return `${nombres.slice(0, -1).join(', ')} o ${nombres[nombres.length - 1]}`;
};

export const totalHabilidades = (areas) =>
  areas.reduce((n, a) => n + a.habilidades.length, 0);
